import { TIndicatorResume } from './types'
import client from '../../client'
import { ResponseSuccess } from '../../types'

export const getIndicatorResume = () =>
  client.get<ResponseSuccess<TIndicatorResume>>(`v1/statement/resume`, {})
